import { RootState } from 'shared/store/store'
import {
  IHistoricTenant,
  ISubleaseApplication,
  ISubleaseFilters,
  ISubleaseList,
  ISubleaseSettings,
} from '../../models/Sublease'

export const getSubleaseList = (state: RootState) => state.tasks.sublease.list

export const getSubleaseDetails = (state: RootState) =>
  state.tasks.sublease.details

export const getSubleaseApplication = (state: RootState) =>
  state.tasks.sublease.details.application
export const getHistoricalTenants = (state: RootState) =>
  state.tasks.sublease.details.historicalTenants

export const getSubleaseEnabled = (state: RootState) =>
  state.tasks?.sublease?.settings?.data?.showSubleaseInPortal

export interface SystemState {
  tasks: {
    sublease: {
      list: {
        data: ISubleaseList | null
        loading: boolean
        error: unknown
        filters: ISubleaseFilters
      }
      details: {
        application: {
          data: ISubleaseApplication
          loading: boolean
          error: unknown
          processing: boolean
          processingError: unknown
          errorMessage: string
        }
        historicalTenants: {
          data: IHistoricTenant[]
          error: unknown
          loading: boolean
        }
      }
      settings: {
        data: ISubleaseSettings
        loading: boolean
        error: unknown
      }
    }
  }
}
